import { Lock } from 'generated/icons';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../contexts';
import Auth from '../../lib/Auth';
import { showSuccessFlash } from '../Flash';

const getUnHijackReturnUrl = (userId: number | undefined) => {
  if (Auth.tokenIsForAdmin()) {
    if (!userId) return '/tokentax-admin';
    return `/tokentax-admin/user/${userId}`;
  }
  if (Auth.tokenIsForOrgOwnerOrAdmin()) {
    return '/clients';
  }
  throw new Error('Hijacker not an admin');
};

export default function HijackedUser() {
  const { user, isHijacked } = useUserContext();
  const history = useHistory();

  const onUnHijack = async () => {
    const url = getUnHijackReturnUrl(user?.id);
    await Auth.unHijack();
    history.push({
      pathname: url,
      state: { unhijack: true },
    });
  };

  const copyUserId = useCallback(() => {
    navigator.clipboard.writeText(user?.id?.toString() || '');
    showSuccessFlash('User ID copied to clipboard');
  }, [user?.id]);

  // Subtracting 1 from the year is more intuitive and in line
  // with how we typically refer to locked years internally
  const lockedThroughYear = user?.lockedThroughYear;

  if (!isHijacked) return null;

  return (
    <>
      {lockedThroughYear && (
        <div
          className="text-white opacity-60 flex gap-1 items-center"
          title={`User account is locked through ${lockedThroughYear}`}
        >
          <Lock size={22} className="text-white" />
          <span className="sm:inline hidden">{lockedThroughYear}</span>
        </div>
      )}

      <button className="text-white opacity-60" onClick={onUnHijack}>
        <span>Unhijack</span>
      </button>

      <button onClick={copyUserId} className="text-white opacity-60">
        <span>ID: {user?.id}</span>
      </button>
    </>
  );
}
